<template>
    <section class="chart-container" >
        <div class=" ml30 mr30" >

            <!--拒绝弹窗界面1-->
            <el-dialog title="拒绝理由" v-model="show_refuse" width="55%" :close-on-click-modal="true" :visible.sync="show_refuse">
                <el-input type="textarea" :rows="3" placeholder="请输入内容" style="width:100%;" v-model="refuse_reason"></el-input>
                <div class="row flex-center mt25"><el-button class="set-other-btn " style="width:343px;" @click.native="sure_refuse">确认拒绝</el-button></div>
            </el-dialog>
            <!--曲线图1-->
            <el-dialog title="皮重曲线图" v-model="show01" width="1040px" :close-on-click-modal="true" :visible.sync="show01" append-to-body="true">
                <div class="w100 row flex-center" style="height:400px;">
                    <div id="myChart" style="width:1000px;height:400px;"></div>
                </div>
            </el-dialog>



            <!--记录查询页 s-->
            <div v-if="active==1">
                <div class="row flex-between" style="align-items:flex-end"><div>
<!--                    <div class="font28 pt20 pb20">过磅记录</div>-->
                <div class=" mb15 row flex-start">
                    <div class="row flex-start"><div>场地名称：</div>
                    <el-select ref="selectValue1" v-model="optionValue" @change="optionValueChange" filterable placeholder="请选择" class="mr25">
                        <el-option
                                v-for="item in optionList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                        />
                    </el-select>
                    </div>
                    <div class="row flex-start">
                        <div>排序：</div> <img src="../../static/img/paixu.svg" class="cursorp p5" @click="paixu" style="width:20px;height:20px;"/>
                    </div>
                </div>
                <div class="row flex-start">
                    <div class="mr15 row flex-center" style="width:340px;">
                        <div style="width:90px;">筛选内容:</div>
                        <el-input
                                placeholder="多个内容：车牌、货物、规格逗号隔开"
                                v-model="recoData.recParams.keywords">
                        </el-input>
                    </div>
                    <div class="row flex-center mr5 ml5"  >
<!--                        <img class="mr5" :src="checked?require('../../static/img/yes01.svg'):require('../../static/img/no01_hq.png')" style="width:18px;height:18px;" />-->
                        自定义日期</div>

<!--                    <el-date-picker-->
<!--                            v-model="recoData.dateValue1"-->
<!--                            type="date"-->
<!--                            placeholder="选择日期">-->
<!--                    </el-date-picker>-->
                    <el-date-picker
                            v-model="recoData.auto_time"
                            type="datetimerange"
                            :picker-options="pickerOptions"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            align="right">
                    </el-date-picker>

                    <div class="row flex-center ml5 mr15"><el-button class="set-other-btn " style="width:73px; height:38px;" @click.native="timeSearch()">搜索</el-button></div>





                </div>

                <div class="row flex-start mt15 mb15">
                <div class="row flex-center mr15 ">过磅类别:</div>
                <el-checkbox-group v-model="recoData.checkList" @change="gblxChange">
                    <el-checkbox v-for="(item,index) in recoData.sendTypeList" :key="index" :label="item" >{{item}}磅单</el-checkbox>
                </el-checkbox-group>
                </div>
                <div class="row flex-between mt15 mb15">
                    <div class="row flex-start">
                        <div class=" row flex-center font24 grey6_text cursorp" :class="recoData.currentRowId!=''?'yellow_bg':'white_bg'"  @click="onquxiantu(0)" style="width:180px;height:60px;border: 1px solid rgba(227, 232, 238, 1);">皮重曲线图</div>
                        <div class=" row flex-center font24 grey6_text ml10" style="width:438px;height:60px;border: 1px solid rgba(227, 232, 238, 1);background:#fff;  ">
                            <div class="row flex-center w100 cursorp" v-print="print">打印例表</div>
                            <div class="row flex-center w100 cursorp" @click="exportExcel"  style="border-left: 1px solid rgba(227, 232, 238, 1);border-right: 1px solid rgba(227, 232, 238, 1);">导出例表</div>
                            <div class="row flex-center w100 cursorp position_r">过磅照片

                                <div class="position_ac w100 h100"><el-image src="../../static/img/yes01.svg" fit="fill"  :preview-src-list="recoData.guobangPics" class="mr8 mb8 w100 h100" style="opacity:0;" ></el-image></div>
                            </div>
                        </div>
                        <div class=" row flex-center font24 grey6_text cursorp white_bg ml10" @click="zuofeiFuc"  style="width:180px;height:60px;border: 1px solid rgba(227, 232, 238, 1);">{{recoData.Valid=='0'?'取消作废':'作废磅单'}}</div>
                    </div>
                </div>
                </div>
                    <div class="white_bg   pt10 mt15  br10 mb15 " style="width:300px;">
                        <div class="pl10 pr10 tc pb10" style="border-bottom:solid 1px #eee">当页总数据( {{recoData.WeighingUnit}} )</div>
                        <div class="row flex-start br5 " style="flex-wrap:wrap;">
                            <div class="column flex-centerall box-sizing w50 pt8 pb8" style="border-right:solid 1px #eee;border-bottom:solid 1px #eee">
                                <div class="fontwb font18">{{recoData.zMz}}</div>
                                <div class="font12 grey9_text">总毛重</div>
                            </div>
                            <div class="column flex-centerall box-sizing w50 pt8 pb8" style="border-bottom:solid 1px #eee">
                                <div class="fontwb font18">{{recoData.zPz}}</div>
                                <div class="font12 grey9_text">总皮重</div>
                            </div>
                            <div class="column flex-centerall box-sizing w50 pt8 pb8" style="border-right:solid 1px #eee;border-bottom:solid 1px #eee">
                                <div class="fontwb font18">{{recoData.zJz}}</div>
                                <div class="font12 grey9_text">总净重</div>
                            </div>
                            <div class="column flex-centerall box-sizing w50 pt8 pb8" style="border-bottom:solid 1px #eee">
                                <div class="fontwb font18">{{recoData.zKz}}</div>
                                <div class="font12 grey9_text">总扣重</div>
                            </div>
                            <div class="column flex-centerall box-sizing w50 pt8 pb8" style="border-right:solid 1px #eee;">
                                <div class="fontwb font18">{{recoData.zSz}}</div>
                                <div class="font12 grey9_text">总实重</div>
                            </div>
                        </div>
                    </div>
<!--                    <div class="row flex-start">-->
<!--                        <div class=" row flex-center font24 grey6_text ml10 cursorp" style="width:438px;height:60px;border: 1px solid rgba(227, 232, 238, 1);background:#f5f7f9;  ">-->
<!--                            <div class="row flex-center w100 position_r h100" @click="onTab3(0)">近一年-->
<!--                                <div class="position_a" v-if="active3==0" style="left: 50%;bottom:10px;margin-left:-33px;width: 67px;height: 5px;opacity: 1;border-radius: 10px;background: rgba(255, 235, 59, 1);box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);"></div>-->
<!--                            </div>-->
<!--                            <div class="row flex-center w100 position_r h100 cursorp" @click="onTab3(1)" style="border-left: 1px solid rgba(227, 232, 238, 1);border-right: 1px solid rgba(227, 232, 238, 1);">近一月-->
<!--                                <div class="position_a" v-if="active3==1" style="left: 50%;bottom:10px;margin-left:-33px;width: 67px;height: 5px;opacity: 1;border-radius: 10px;background: rgba(255, 235, 59, 1);box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);"></div>-->
<!--                            </div>-->
<!--                            <div class="row flex-center w100 position_r h100 cursorp" @click="onTab3(2)" style="border-left: 1px solid rgba(227, 232, 238, 1);border-right: 1px solid rgba(227, 232, 238, 1);">近一周-->
<!--                                <div class="position_a" v-if="active3==2" style="left: 50%;bottom:10px;margin-left:-33px;width: 67px;height: 5px;opacity: 1;border-radius: 10px;background: rgba(255, 235, 59, 1);box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);"></div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="row flex-center ml25 font18" style="width: 512px;height: 82px;border-radius: 4px;box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);">-->
<!--                            <div class="w100 column flex-centerall"><div>{{recoData.dateTypeValue.name}}</div><div>{{recoData.dateTypeValue.value}}{{recoData.WeighingUnit}}</div></div>-->
<!--                            <div class="w100 column flex-centerall" style="border-left:solid 1px #A6A6A6;border-right:solid 1px #A6A6A6"><div>{{recoData.dateTypeValue2.name}}</div><div>{{recoData.dateTypeValue2.value}}{{recoData.WeighingUnit}}</div></div>-->
<!--                            <div class="w100 column flex-centerall"><div>{{recoData.dateTypeValue3.name}}</div><div>{{recoData.dateTypeValue3.value}}次</div></div>-->
<!--                        </div>-->
<!--                    </div>-->
                </div>



                <template>

                    <div id="printArea">
                    <el-table v-fit-columns  v-loading = "isLoading"  element-loading-background = "rgba(255, 255, 255, .5)"  :element-loading-text = "loadText"  element-loading-spinner = "el-icon-loading"  :height="recoData.recParams.page_size==10?570:570"  :data="recoData.list"  id="ExportExcelTable"   :row-style="rowStyle"  @row-click="changeCurrentRow">
                            <el-table-column  :prop="item.Key"  :label="item.Value"   v-for="(item,index) in recoData.setData" :key="index" >
                            </el-table-column>
                    </el-table>

<!--                    < :default-sort="{ prop: 'Ch', order: 'descending' }" el-table :data="recoData.list" class="data_table" :default-sort="{ prop: 'Ch', order: 'descending' }"  :row-style="rowStyle"  @row-click="changeCurrentRow">-->
<!--                        <el-table-column :prop="item.Key"  :label="item.Key"   v-for="(item,index) in recoData.setData" :key="index" >-->
<!--                        <template slot-scope="scope">-->
<!--                            <span>{{scope.row.uuid}}</span>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
<!--                    </el-table> show-overflow-tooltip-->

                     <div class="row flex-between">
                         <div></div>
                         <div class="row flex-start font12">
<!--                             <div class="row flex-start" style="align-items:flex-start">-->
<!--                                 <div><div>当页总数据：</div><div class="yellow_bg" style="width:65px;height:8px;margin-top:-7px;"></div></div>-->
<!--                                 <div class="ml15 mr15"><div>总毛重:{{recoData.zMz}}{{recoData.WeighingUnit}}</div><div>总皮重:{{recoData.zPz}}{{recoData.WeighingUnit}}</div><div>总净重:{{recoData.zJz}}{{recoData.WeighingUnit}}</div></div>-->
<!--                                 <div class="mr30"><div>总扣重:{{recoData.zKz}}{{recoData.WeighingUnit}}</div><div>总实重:{{recoData.zSz}}{{recoData.WeighingUnit}}</div></div>-->
<!--                             </div>-->
                             <el-pagination background layout="total,sizes,prev, pager, next"     :page-size="recoData.recParams.page_size"  :page-sizes="[10,20,30,40,50,100,200,500,1000,2000]" :total="recoData.total"  popper-class='select_bottom'
                                           v-model:currentPage="recoData.recParams.page" v-model:page-size="recoData.recParams.page_size"
                                           @current-change="handleCurrentChange" @size-change="handleSizeChange" style="margin: 20px 0 20px 0;" />
                         </div>
                     </div>

                    </div>

                </template>




            </div>
            <!--记录查询页 e-->
        </div>


<!--<div style="height: 200px"> </div>-->
    </section>
</template>

<script>
    import axios from "axios";
    import XLSX from 'xlsx'
    import echarts from 'echarts'
    import print from 'vue-print-nb'
    import { showLoading, hideLoading } from '../utils/common.js';
directives: {
  print
}


    export default {
        data() {
            return {
print: {
        id: 'printArea',
        popTitle: '配置页眉标题', // 打印配置页上方的标题
        extraHead: '打印', // 最上方的头部文字，附加在head标签上的额外标签，使用逗号分割
        preview: true, // 是否启动预览模式，默认是false
        previewTitle: '预览的标题', // 打印预览的标题
        previewPrintBtnLabel: '预览结束，开始打印', // 打印预览的标题下方的按钮文本，点击可进入打印
        zIndex: 20002, // 预览窗口的z-index，默认是20002，最好比默认值更高
        previewBeforeOpenCallback () { console.log('正在加载预览窗口！'); console.log("that.msg", this) }, // 预览窗口打开之前的callback
        previewOpenCallback () { console.log('已经加载完预览窗口，预览打开了！') }, // 预览窗口打开时的callback
        beforeOpenCallback () { console.log('开始打印之前！') }, // 开始打印之前的callback
        openCallback () { console.log('执行打印了！') }, // 调用打印时的callback
        closeCallback () { console.log('关闭了打印工具！') }, // 关闭打印的callback(无法区分确认or取消)
        clickMounted () { console.log('点击v-print绑定的按钮了！') },
        // url: 'http://localhost:8080/', // 打印指定的URL，确保同源策略相同
        // asyncUrl (reslove) {
        //   setTimeout(() => {
        //     reslove('http://localhost:8080/')
        //   }, 2000)
        // },
        standard: '',
        extarCss: ''
      },
            active:1,
            active2:0,
            active3:0,
	      week:'',// 本周周几
	      date_show:'', //本日日期
	      list:[],
	      refuse_reason:'',
	      show_refuse:false,
	      curId:'',
          checked: false,
          totalA:0,
          totalB:0,
          totalC:0,
          keywords:'',
          keywordempty:false,
          isRes:false,
          mywidth:'',

     pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        auto_audit_time: '',

        srcList: [],
	    optionList: [],
        optionValue: '',


                user: JSON.parse(window.localStorage.getItem('user')),

                isLoading:false,//表格加载
                loadText:'正在加载…请耐心等待',
                loadText1:'正在加载…请耐心等待',
                loadText2:'数据比较多正在加载…请耐心等待',
                show01:false,//曲线图弹窗
                myChart: {},
                xData: [], //横坐标
                yData: [], //y数据
                recoData:{
                    checked: false,//时间选中
                    auto_time:'',
                    WeighingUnit:'',//单位
                    curCh:'',//当前选中行的车牌号
                    guobangPics:[],//当前选中行的照片
                    currentRowId:'',//当前选中行的id
                    Valid:'',//当前选中行的Valid是否作废
                    list:[],//表格list
                    total:0,//表格toal
                    keywords:'',
                    recParams:{
                        api:'weighingrecord',
                        methods:'get',
                        machine_code:'',
                        page_size:10,
                        page:1,
                        order:'desc',
                        data:'',
                        conditions:{Valid:1},
                        keywords:'',
                        createtime_begin_at:'',
                        createtime_end_at:'',

                    },
                    setData:[],//表格-表头数据
                    dateValue:'',
                    checkList: [],
                    sendTypeList:['采购','销售','其他','作废'],
                    dateType:'year',//年月日筛选
                    dateTypeValue:{},//毛重
                    dateTypeValue2:{},//净重
                    dateTypeValue3:{},//车次
                    zMz:'',
                    zPz:'',
                    zJz:'',
                    zKz:'',
                    zSz:'',
                    zCc:'',
                }
            }
        },

        mounted: function () {
                this.resetData()
  		        this.getoptionList()
        },
        methods: {


//记录查询页 s
        optionValueChange(e){
                    this.onRefresh2()
        },
     resetData() {
            this.recoData.curCh=''
            this.recoData.guobangPics=[]
            this.recoData.currentRowId=''
            this.recoData.Valid=''
            this.recoData.keywords=''
            this.recoData.list=[];
            this.recoData.total=0;
            this.recoData.recParams.conditions={Valid:1};
            this.recoData.recParams.createtime_begin_at='';
            this.recoData.recParams.createtime_end_at='';
            this.recoData.recParams.keywords='';
            this.recoData.recParams.page=1;
            this.recoData.recParams.page_size=10;
            this.recoData.dateType='year';
            this.recoData.dateTypeValue='';
            this.recoData.dateTypeValue2='';
            this.recoData.dateTypeValue3='';
         },
     onRefresh2() {
            this.resetData()
            this.getRecoredList()
            this.get_weighing_statistics()
         },
getSummaries(list) {
           let values = list.map(item => Number(item['Mz']));
           let values2 = list.map(item => Number(item['Pz']));
           let values3 = list.map(item => Number(item['Jz']));
           let values4 = list.map(item => Number(item['Kz']));
           let values5 = list.map(item => Number(item['Sz']));
           let values6 = list.map(item => Number(item['Cc']));
           console.log(values2)
              let a=0;
              for(let i=0;i<values.length;i++){
                a+=values[i];
              }
              console.log("a")
              console.log(a)
              let b=0;
              for(let j=0;j<values2.length;j++){
                b+=values2[j];
              }
              console.log("b")
              console.log(b)
              let c=0;
              for(let k=0;k<values3.length;k++){
                c+=values3[k];
              }
              console.log("c")
              console.log(c)
              let d=0;
              for(let t=0;t<values4.length;t++){
                d+=values4[t];
              }
              console.log("d")
              console.log(d)
              let e=0;
              for(let y=0;y<values5.length;y++){
                e+=values5[y];
              }
              console.log("e")
              console.log(e)
              let f=0;
              for(let p=0;p<values5.length;p++){
                f+=values6[p];
              }
              this.recoData.zMz=a.toFixed(2)
              this.recoData.zPz=b.toFixed(2)
              this.recoData.zJz=c.toFixed(2)
              this.recoData.zKz=d.toFixed(2)
              this.recoData.zSz=e.toFixed(2)
              this.recoData.zCc=f.toFixed(2)
          },



         getRecoredList(e){
            let self=this
            self.isLoading = true;
            let recParams=self.recoData.recParams
            if(recParams.page_size>100){
                self.loadText=self.loadText2
            }else{
                self.loadText=self.loadText1
            }
            recParams.machine_code=self.optionValue
            this.$axios.get(this.baseApiUrl+'appointment/weighing_record_list',{"params": recParams}).then(function (res) {
                self.isLoading = false;
                if(res.data.code==1){
                    self.recoData.total=res.data.data.total
                    let mylist=res.data.data.data
                    mylist = mylist.map(t => {
                              if(t.pic_url){
                                  t.pic_url=t.pic_url.split(',');
                             }
                              return t;
                     })

                 if(e&&e.length>0){
                    if(e=='exportExcel'){
                        self.exportList(mylist)//打印
                        return;
                    }
                    let evalue=e
                    if(e.length==1&&e[0]=='作废'){
                    self.recoData.list=mylist
                    self.getSummaries(mylist)
                    }else{
                    let mylist2 =mylist.filter(t=>evalue.indexOf(t.Gblx)!=-1);
                    self.recoData.list=mylist2
                    self.getSummaries(mylist2)
                    }
                 }
                  else{
                    self.recoData.list=mylist
                    self.getSummaries(mylist)
                  }



                }

                   self.$axios.get(self.baseApiUrl+'uploadata/getjsonkey',{"params": recParams}).then(function (res) {
                        if(res.data.code==1){
                             let resList=res.data.data.value.Details[0].Settings//表头

                             resList = resList.map(t => {
                                 if(t.Key.charAt(0)=='_'){
                                    let str=t.Key.slice(1)
                                    t.Key=str.slice(0,1).toUpperCase() +str.slice(1).toLowerCase();
                                }
                                if(t.Key=='WeighingUnit'){
                                self.recoData.WeighingUnit=t.Value
                                }
                                return t;
                            })

                           let arr = []
                           let arr2 = []



                            for (let key in self.recoData.list[0]) {

                            if(self.recoData.list[0][key]!=null){
                              arr.push(self.recoData.list[0][key])
                              arr2.push(key)

                              }
                            }

                            console.log(arr)//值
                            console.log(arr2)//对象名
                            let abc=[]
for(let i=0;i<arr2.length;i++){
for(let j=0;j<resList.length;j++){
if(resList[j].Key==arr2[i]){
abc.push(resList[j])
}
}

}

                            self.recoData.setData=abc


                        }
                   })
            })
        },



timeSearch(){//记录 筛选时间范围
    let self=this;
    console.log("点击 时间")
    self.recoData.recParams.createtime_begin_at=self.recoData.auto_time?self.recoData.auto_time[0]:''
    self.recoData.recParams.createtime_end_at=self.recoData.auto_time?self.recoData.auto_time[1]:''
     this.getRecoredList()

},
paixu(){//点击排序
    let self=this;
    console.log("点击排序")
    self.recoData.recParams.order=self.recoData.recParams.order=='desc'?'':'desc'
     this.getRecoredList()

},
get_weighing_statistics(){//获取称重统计
let self=this
let params={type:self.recoData.dateType,machine_code:self.optionValue}
self.$axios.post(self.baseApiUrl+'uploadata/get_weighing_statistics',params).then(function (res) {
 if(res.data.code==1){
 self.recoData.dateTypeValue=res.data.data.Mz
 self.recoData.dateTypeValue2=res.data.data.Jz
 self.recoData.dateTypeValue3=res.data.data.Ccjl
 }
})
},
        handleSizeChange (val) {
            this.recoData.recParams.page_size = val
            this.getRecoredList()
        },
        handleCurrentChange  (val) {
            this.recoData.recParams.page = val
            this.getRecoredList()
        },




gblxChange(e){//过磅类型筛选
console.log(e)
console.log(this.recoData.checkList)
if(e.length>0){
    this.recoData.recParams.page = 1
    this.recoData.recParams.page_size = 100
}else{
    this.recoData.recParams.page = 1
    this.recoData.recParams.page_size = 10
}
if(e.indexOf('作废')!=-1){
    console.log("有 作废")
    this.recoData.recParams.conditions.Valid=0
}else{
    this.recoData.recParams.conditions.Valid=1
}
  this.getRecoredList(e)
},






            exportExcel(){//导出表格
               let self=this;
                   this.$confirm('是否下载？', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning',
                      center: true
                }).then(() => {
                    //self.recoData.recParams.page_size = 100
                    self.getRecoredList('exportExcel')
                })

            },
          exportList(list){
            console.log("exportList")
            showLoading('正在导出，请耐心等待...');
            var XLSX = require("xlsx")
              let setData = this.recoData.setData// 表格表头
                let setData2=setData.map(t => {
                    return t.Value;
                })
                let setData3=setData.map(t => {
                    return t.Key;
                })
                setData2.unshift('序号')
                let tableData = []
                tableData.push(setData2)

                                console.log("setData3.length")
                                console.log(setData3.length)
                            list.forEach ((item,index)=> {
                                let rowData = []
                                //导出内容的字段
                                rowData = [
                                    index+1,
                                    //for(let i=0;i<setData3.length;i++){
                                    //item[setData3[i]],
                                    //}
                                    item[setData3[0]],
                                    item[setData3[1]],
                                    item[setData3[2]],
                                    item[setData3[3]],
                                    item[setData3[4]],
                                    item[setData3[5]],
                                    item[setData3[6]],
                                    item[setData3[7]],
                                    item[setData3[8]],
                                    item[setData3[9]],
                                    item[setData3[10]],
                                    item[setData3[11]],
                                    item[setData3[12]],
                                    item[setData3[13]],
                                    item[setData3[14]],
                                    item[setData3[15]],
                                    item[setData3[16]],
                                    item[setData3[17]],
                                    item[setData3[18]],
                                    item[setData3[19]],
                                    item[setData3[20]],
                                    item[setData3[21]],
                                    item[setData3[22]],
                                    item[setData3[23]],
                                    item[setData3[24]],
                                    item[setData3[25]],
                                    item[setData3[26]],
                                ]
                                tableData.push(rowData)
                             })

                let ws = XLSX.utils.aoa_to_sheet(tableData)
                let wb = XLSX.utils.book_new()
                XLSX.utils.book_append_sheet(wb, ws, '例表') // 工作簿名称
                XLSX.writeFile(wb, '例表.xlsx') // 保存的文件名
                hideLoading();
            },



            changeCurrentRow(row, column, event) {
              if (this.recoData.currentRowId == row.uuid){
              this.recoData.curCh = ''
              this.recoData.currentRowId = ''
              this.recoData.guobangPics=[]
              this.recoData.Valid=''
              }else{
              this.recoData.currentRowId = row.uuid
              this.recoData.guobangPics=row.pic_url
              this.recoData.curCh=row.Ch
              this.recoData.Valid=row.Valid
              console.log(row)
              console.log(row.uuid)
              console.log(this.recoData.currentRowId)
              }
              console.log("this.recoData.guobangPics")
              console.log(this.recoData.guobangPics)
              this.recoData.guobangPics.forEach((item,index)=> {
                  if(item==''){
                  this.recoData.guobangPics.splice(index,1)
                  }
              })
              console.log("this.recoData.guobangPics2")
              console.log(this.recoData.guobangPics)
              console.log(this.recoData.currentRowId)
            },
            rowStyle ({row, rowIndex}) {
              if (this.recoData.currentRowId === row.uuid) {
                // 此处返回选中行的样式对象，按需设置
                return {
                  'background-color': '#e3e8ee',
                }
              }
            },

get_pz_weight_record(){//根据车牌获取近100条皮重称重记录（曲线图数据）
let self=this
self.yData=[]
self.xData=[]
let params={Ch:self.recoData.curCh,machine_code:self.optionValue}
self.$axios.post(self.baseApiUrl+'uploadata/get_pz_weight_record',params).then(function (res) {
 if(res.data.code==1){
    //self.recoData.list=res.data.data
    console.log("res.data.data曲线图数据")
    console.log(res.data.data)
    let mylist=res.data.data
     mylist = mylist.map(t => {
             if(t.Pz){self.yData.push(t.Pz)}
             if(t.Pzrq){self.xData.push(t.Pzrq.substring(5, 16))}
          return t;
        });
self.xData=self.xData.reverse()
self.yData=self.yData.sort()
console.log("self.yData")
console.log(self.yData)
console.log(self.xData)
self.drawLine()
 }
})
},

                zuofeiFuc(id) {
                    let self=this;
                    if(this.recoData.currentRowId==''){
                    return;
                    }
                    let valid=this.recoData.Valid==1?0:1
                    let myText=this.recoData.Valid==1?'是否确认作废？':'是否确认取消作废？'
                    let params={model:'weighingrecord',uuid:this.recoData.currentRowId,Valid:valid}
                       this.$confirm(myText, '提示', {
                          confirmButtonText: '确定',
                          cancelButtonText: '取消',
                          type: 'warning',
                          center: true
                    }).then(() => {
                                           self.$axios.post(this.baseApiUrl+'account4/machine_data/machine_data/edit',params).then(function (res) {
                                             console.log("作废接口")
                                                self.$message({
                                                    type: 'success',
                                                    message: '操作成功!'
                                                  });
                                                  self.onRefresh2()
                                             }).catch(error => {
                                              self.$message({
                                                 message: error.message,
                                                  type: 'warning'
                                              });
                                            });
                    }).catch(() => {
                    });
                },

onquxiantu(){
if(this.recoData.currentRowId==''){
return;
}
this.show01=!this.show01
this.get_pz_weight_record()
},


 drawLine () {
 console.log("曲线图")
        const option = {
        xAxis: {
          data: this.xData
        },
        yAxis: {
          data: this.yData,name: this.recoData.WeighingUnit,},
        series: [
          {
            data: this.yData,
            type: "line", // 类型设置为折线图
             itemStyle: {
                normal: {
                    color: '#165DFF', //改变折线点的颜色
                    lineStyle: {
                        color: '#165DFF' //改变折线颜色
                    }
                }
            },
          }
        ]
      };


      this.myChart = echarts.init(document.getElementById("myChart"));
      this.myChart.setOption(option);
      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        this.myChart.resize();
      });
    },













//记录查询页 e
            onTab(val){
              this.active=val
              if(val==1){
              this.onRefresh2()
              }else{
              this.onRefresh()
              }
            },
            onTab2(val){
              this.active2=val
              this.onRefresh()
            },
            onTab3(val){
              this.active3=val
              this.recoData.dateType=val==2?'week':val==1?'month':'year'
              this.get_weighing_statistics()
            },
         onRefresh() {
            this.isRes=false
            this.curId=''
            this.keywords=''
            this.keywordempty=false
            this.list=[];
            this.getList();
  		   this.getoptionList()
         },






getList(){
    let self=this;
    let params={
    status:self.active2
    }
    let params1={
    status:1
    }
    let params2={
    status:2
    }
     //const rLoading = this.openLoading();
     self.$axios.get(self.baseApiUrl+'appointment/get_appointment_list_4',{"params": params}).then(function (res) {
     let resList=res.data.data
let srcList=[]
 resList = resList.map(t => {
 t.srcList=[]

     if(t.car_images){
          t.car_images=t.car_images.split(',');
          t.srcList=t.srcList.concat(t.car_images)
     }
     if(t.idcard_images){
          t.idcard_images=t.idcard_images.split(',');
          t.srcList=t.srcList.concat(t.idcard_images)
     }
     if(t.license_images){
          t.license_images=t.license_images.split(',');
          t.srcList=t.srcList.concat(t.license_images)
     }

          return t;
        });
console.log("resList")
console.log(resList)
console.log("srcList")

     self.list=resList
     if(self.active2==0){
let resList2 =resList.filter(t=>t.status==0);
console.log("resList--0")
console.log(resList2)
     self.list=resList2
self.totalA=resList2.length
     }
        self.isRes=true
     self.$axios.get(self.baseApiUrl+'appointment/get_appointment_list_4',{"params": params1}).then(function (res) {
        self.totalB=res.data.data.length
        self.$axios.get(self.baseApiUrl+'appointment/get_appointment_list_4',{"params": params2}).then(function (res) {
            self.totalC=res.data.data.length
self.$axios.get(self.baseApiUrl+'user/getUserList').then(function (res) {
console.log("getUserList-res")
let out_user=res.data.data.out_user
out_user = out_user.map(t => {
return t.id
})
console.log(out_user)
})
      })
      })
     }).catch(error => {
      self.$message({
         message: error.message,
          type: 'warning'
      });
       //rLoading.close();
    });
},

getoptionList(){
let self=this
 let machparam={type:2}
        self.$axios.post(self.baseApiUrl+'rsa/get_machine_code_list',machparam).then(function (res) {
            console.log("get_machine_code_list-res")
            console.log(res.data.data)
            let resdata=res.data.data
            let optionList = resdata.map(t => {
            return {
               value: t.machine_code,
                label:t.remark
               }
             })
            console.log("optionList")
            console.log(optionList)
            self.optionList=optionList

                let machparam1={type:1}
                self.$axios.post(self.baseApiUrl+'rsa/get_machine_code_list',machparam1).then(function (res) {
                    console.log("get_machine_code_list-res2")
                    console.log(res.data.data)
                    let resdata2=res.data.data
                    let optionList2 = resdata2.map(t => {
                        return {
                            value: t.machine_code,
                            label:t.remark
                           }
                     })
                    self.optionList=self.optionList.concat(optionList2)
                    self.optionValue=self.optionList[0].value
                    if(self.active==1){
                    self.getRecoredList()
                    self.get_weighing_statistics()
                    }

                })

        })
        },
check_appointment(id,val){
    let self=this;
    let params={
    uuid:id,
    status:val,
    refuse_reason:self.refuse_reason?self.refuse_reason:''
    }
     this.$axios.post(this.baseApiUrl+'appointment/check_appointment',params).then(function (res) {
     console.log("res-check_appointment")
        self.$message({
            type: 'success',
            message: '提交成功!'
          });
          self.onRefresh()
     }).catch(error => {
      self.$message({
         message: error.message,
          type: 'warning'
      });
    });
},

open(id) {
    let self=this;
       this.$confirm('是否确认通过审批？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
    }).then(() => {
    self.check_appointment(id,1)
    }).catch(() => {
    });
},

sure_refuse() {
    let self=this;
    self.close_refuse();
    self.check_appointment(self.curId,2)
},

open_refuse(id) {
    let self=this;
    self.curId=id
      this.show_refuse=true
},
close_refuse() {
    let self=this;
    this.show_refuse=false
},

// 获取当前系统日期
getdataTime(){
  let wk = new Date().getDay()
  let yy = new Date().getFullYear();
  let mm = new Date().getMonth() + 1;
  let dd = new Date().getDate();
  let weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
  this.week = weeks[wk]
  this.date_show =  mm + "月" + dd + "日"

},
// 获取当前系统的时间
getnewTime(){
  let hh = new Date().getHours();
  let mf =
    new Date().getMinutes() < 10
      ? "0" + new Date().getMinutes()
      : new Date().getMinutes();
  let ss =
    new Date().getSeconds() < 10
      ? "0" + new Date().getSeconds()
      : new Date().getSeconds();
  this.time_show = hh + ":" + mf + ":" + ss;
},


//自动审核开启关闭
editAutoAuditConfig2(){
    let self=this;

    let params={
    is_auto_audit:self.checked?1:0,
    auto_audit_begin_time:self.auto_audit_time?self.auto_audit_time[0]:'',
    auto_audit_end_time:self.auto_audit_time?self.auto_audit_time[1]:'',
    account6_uid:''
    }

    if(self.checked){//关闭
               this.$confirm('是否确认关闭自动审核？', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning',
                      center: true
                }).then(() => {

        this.$axios.post(this.baseApiUrl+'appointment/editAutoAuditConfig',params).then(function (res) {
            console.log("editAutoAuditConfig2-关")
            if(res.code==1){
                self.checked=false
                self.$message({type: 'success',message: '提交成功!'});
                self.onRefresh()
            }
        })
})
    }else{//开启
      if(!self.auto_audit_time||self.auto_audit_time.length==0){
             this.$alert('请先选择时间', {
                 confirmButtonText: '确定',
            });
            return;
        }
this.$axios.post(this.baseApiUrl+'appointment/editAutoAuditConfig',params).then(function (res) {
        console.log("editAutoAuditConfig2-开")
        console.log(res)
    if(res.code==1){
         self.checked=true
        self.$message({type: 'success',message: '提交成功!'});
        self.onRefresh()
        }
})


    }


},


editAutoAuditConfig(){//确定按钮
    let self=this;


if(self.keywords.length>0){
console.log("关键字搜索")
let list=self.list
let keyList=[]
    for(let i=0;i<list.length;i++){
        if(list[i].car.PlateNo.indexOf(self.keywords) != -1||list[i].spec.GoodsName.indexOf(self.keywords) != -1||list[i].customer.Name.indexOf(self.keywords) != -1){
        keyList.push(list[i])
        console.log("keyList")
        console.log(keyList)
         self.list=keyList
         self.keywordempty=false
        }else{
           self.keywordempty=true
        }
    }

}else{
this.onRefresh()
}



},

valueDateChange(){
console.log("valueDateChange")
console.log(this.auto_audit_time)
self.checked=false

},




        }


    }
</script>

<style lang="scss">
.select_bottom{
  .el-select-dropdown__item.selected{
    color:#000;
  }
  .el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
    background:#fef03e;
    color:#666;
  }
}
  .el-select .el-input.is-focus .el-input__inner {
    border-color: #fef03e;
    }
  .el-select .el-input .el-input__inner:hover{
    border-color: #fef03e;
    }
  .el-pagination.is-background .el-pager li:not(.disabled).active{background-color: #fef03e;color:#333}

  .el-pagination.is-background .el-pager li:not(.disabled):hover{background-color: #fef03e;color:#333}
</style>



// WEBPACK FOOTER //
// Main.vue?50b745e4